"use strict";

require("core-js/modules/es.function.name");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _native = _interopRequireDefault(require("@emotion/native"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _reactNative = require("react-native");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Label =
/*#__PURE__*/
_native["default"].Text(function (_ref) {
  var theme = _ref.theme;
  return {
    fontSize: 17,
    color: theme.labelColor
  };
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy90eXBlcy9CdXR0b24uanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBS2MiLCJmaWxlIjoiLi4vLi4vc3JjL3R5cGVzL0J1dHRvbi5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBQcm9wVHlwZXMgZnJvbSAncHJvcC10eXBlcyc7XG5pbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnO1xuaW1wb3J0IHsgVG91Y2hhYmxlT3BhY2l0eSB9IGZyb20gJ3JlYWN0LW5hdGl2ZSc7XG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL25hdGl2ZSc7XG5cbmNvbnN0IExhYmVsID0gc3R5bGVkLlRleHQoKHsgdGhlbWUgfSkgPT4gKHtcbiAgZm9udFNpemU6IDE3LFxuICBjb2xvcjogdGhlbWUubGFiZWxDb2xvcixcbn0pKTtcblxuY29uc3QgQnV0dG9uVHlwZSA9ICh7IGtub2IsIG9uUHJlc3MgfSkgPT4gKFxuICA8VG91Y2hhYmxlT3BhY2l0eSBzdHlsZT17eyBtYXJnaW46IDEwIH19IG9uUHJlc3M9eygpID0+IG9uUHJlc3Moa25vYil9PlxuICAgIDxMYWJlbD57a25vYi5uYW1lfTwvTGFiZWw+XG4gIDwvVG91Y2hhYmxlT3BhY2l0eT5cbik7XG5cbkJ1dHRvblR5cGUuZGVmYXVsdFByb3BzID0ge1xuICBrbm9iOiB7fSxcbn07XG5cbkJ1dHRvblR5cGUucHJvcFR5cGVzID0ge1xuICBrbm9iOiBQcm9wVHlwZXMuc2hhcGUoe1xuICAgIG5hbWU6IFByb3BUeXBlcy5zdHJpbmcsXG4gIH0pLFxuICBvblByZXNzOiBQcm9wVHlwZXMuZnVuYy5pc1JlcXVpcmVkLFxufTtcblxuQnV0dG9uVHlwZS5zZXJpYWxpemUgPSB2YWx1ZSA9PiB2YWx1ZTtcbkJ1dHRvblR5cGUuZGVzZXJpYWxpemUgPSB2YWx1ZSA9PiB2YWx1ZTtcblxuZXhwb3J0IGRlZmF1bHQgQnV0dG9uVHlwZTtcbiJdfQ== */");

var ButtonType = function ButtonType(_ref2) {
  var knob = _ref2.knob,
      _onPress = _ref2.onPress;
  return _react["default"].createElement(_reactNative.TouchableOpacity, {
    style: {
      margin: 10
    },
    onPress: function onPress() {
      return _onPress(knob);
    }
  }, _react["default"].createElement(Label, null, knob.name));
};

ButtonType.defaultProps = {
  knob: {}
};
ButtonType.propTypes = {
  knob: _propTypes["default"].shape({
    name: _propTypes["default"].string
  }),
  onPress: _propTypes["default"].func.isRequired
};

ButtonType.serialize = function (value) {
  return value;
};

ButtonType.deserialize = function (value) {
  return value;
};

var _default = ButtonType;
exports["default"] = _default;